module.exports = __webpack_public_path__ + "static/media/no-icon.3f73099a.svg";